import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export interface WorkTypeTemplateLine {
  id: number;
  areaName: string;
  areaSortOrder: number;
  chapterName: string;
  chapterSortOrder: number;
  sortOrder: number;
  articleId?: number | null;
  code: string;
  description: string;
  unit: string;
  quantity: number;
  quantityPerArea: boolean;
  unitPrice: number;
  marginPercent?: number | null;
}

export interface WorkTypeDetail {
  id: number;
  name: string;
  sortOrder: number;
  templateLines: WorkTypeTemplateLine[];
}

export interface WorkTypeTemplateLineInput {
  areaName: string;
  chapterName: string;
  articleId?: number | null;
  code: string;
  description: string;
  unit: string;
  quantity: number;
  quantityPerArea: boolean;
  unitPrice: number;
  marginPercent?: number | null;
}

export interface CreateBudgetFromWorkTypePayload {
  workTypeId: number;
  workArea: number;
  workName: string;
  clientId?: number | null;
  responsible?: string | null;
  orderReference?: string | null;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getWorkTypeById(workTypeId: number): Promise<WorkTypeDetail> {
  return request<WorkTypeDetail>(`/api/work-types/${workTypeId}`);
}

export function saveWorkTypeTemplate(
  workTypeId: number,
  lines: WorkTypeTemplateLineInput[],
): Promise<WorkTypeDetail> {
  return request<WorkTypeDetail>(`/api/work-types/${workTypeId}/template`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ workTypeId, lines }),
  });
}

export function createBudgetFromWorkType(
  payload: CreateBudgetFromWorkTypePayload,
): Promise<number> {
  return request<number>("/api/budgets/from-work-type", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
